import React from 'react'
import Common from './Common'
import anil1 from './anil1.png'


const Home=() =>{
  return (
      <>

      <Common name="Grow Your Money With " name1="Providing Insurance Protection for you & your family!
" getstarted="Get Started" imgUrl={anil1} card="FundGuard has been launched by Ram Kumar Sahu as a flagship company to offer Insurance & Financial Products & related Services to individuals and businesses within Delhi NCR.

FundGuard is known for its industry competence, agility, trust and highest level of integrity in analysing/recommending unique financial solutions to its clients based on their specific needs. It has been known for its client centric services and has been well recognized for after sale service to the clients to support their day to day queries/clarifications, policy related services and others." cardtittle="Founder"/>

       </>
  )
}

export default Home
